import type { OceanBedrockModel } from "@vida/currents-core";
import { CurrentsAPI } from "@vida/currents-core";
import { apiFetch } from "../api";
import { createCurrentsApiConfig } from "./currentsSession";
import { BEDROCK_MODEL_FALLBACK } from "./agentCatalog";

async function loadFromAdminApi(): Promise<OceanBedrockModel[]> {
  const res = await apiFetch<{ models: OceanBedrockModel[] }>("/api/ocean/bedrock-models");
  return Array.isArray(res.models) ? res.models.filter((m) => m.enabled !== false) : [];
}

async function loadFromGraphQL(): Promise<OceanBedrockModel[]> {
  return CurrentsAPI.listBedrockModels(createCurrentsApiConfig());
}

export type BedrockModelsLoadResult = {
  models: OceanBedrockModel[];
  source: "admin-api" | "graphql" | "fallback";
  warnings: string[];
};

export async function loadBedrockModels(): Promise<BedrockModelsLoadResult> {
  const warnings: string[] = [];

  try {
    const admin = await loadFromAdminApi();
    if (admin.length > 0) {
      return { models: admin, source: "admin-api", warnings };
    }
    warnings.push("admin-api ha risposto ma il catalogo è vuoto");
  } catch (e) {
    warnings.push(`admin-api: ${e instanceof Error ? e.message : String(e)}`);
  }

  try {
    const gql = await loadFromGraphQL();
    if (gql.length > 0) {
      return { models: gql, source: "graphql", warnings };
    }
    warnings.push("GraphQL ha risposto ma il catalogo è vuoto");
  } catch (e) {
    warnings.push(`GraphQL: ${e instanceof Error ? e.message : String(e)}`);
  }

  warnings.push("Uso elenco modelli locale (esegui sync + deploy admin-api per il catalogo DynamoDB)");
  return { models: BEDROCK_MODEL_FALLBACK, source: "fallback", warnings };
}
